module.exports = __webpack_public_path__ + "static/media/usda_bug.208dbf6f.png";